import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css';
import logoImg from '../images/logo.png';
import './menuOpciones.css';
import CargaLayout from '../images/iconosMenu/CARGA_LAYOUT.png';
import Dashboard from '../images/iconosMenu/dashboard.png';
import ReportesEsp from '../images/iconosMenu/REPORTES_ESP.png';
import AdminUsuarios from '../images/iconosMenu/ADMIN_USUARIO.png';
import logoOmnixOficial from '../images/logoOmnixOficial.png';

function MenuOpciones() {
  const navigate = useNavigate();
  const [user, setUser] = useState({}); // Inicializa como objeto vacío
  
  const userStored = JSON.parse(localStorage.getItem('user'));

  if (userStored) {
    document.documentElement.style.setProperty('--colorPrincipal', userStored.colores.colorPrincipal);
    document.documentElement.style.setProperty('--colorSecundario', userStored.colores.colorSecundario);
    document.documentElement.style.setProperty('--white', userStored.colores.white);
    document.documentElement.style.setProperty('--grisOscuro', userStored.colores.grisOscuro);
  }
  

  console.log(user.email)

  return (
    <div>
      <div className="container w-100 text-center">
        <div className="row mt-5 g-2 g-lg-3 align-items-center">
          <div className="col-4">
            <div className=""><img src={logoOmnixOficial} alt="Perfil" height={200} /></div>
          </div>
          <div className="col-8 d-flex align-items-center">
            <h1 className="p-3 texto-principal fw-bold">
              Bienvenido al Sistema de Información Estadística Infográfica
            </h1>
          </div>
        </div>
      </div>
      <hr />
      <center>
        <div className="row row-cols-2">
          <div className="col menu-item text-center" onClick={() => navigate('/usuarios')}>
            <img src={AdminUsuarios} alt="Administración de Usuarios" className="menu-icon mb-3" /> <br />
            <button className="menuOpc">Administración de usuarios</button>
          </div>
          <div className="col menu-item text-center" onClick={() => navigate('/dashboard')}>
            <img src={Dashboard} alt="Visualizar Dashboard" className="menu-icon mb-3" /> <br />
            <button className="menuOpc">Dashboard Infográficos</button>
          </div>
          <div className="col menu-item text-center" onClick={() => navigate('/cargar-layouts')}>
            <img src={CargaLayout} alt="Carga de Layouts" className="menu-icon mb-3" /> <br />
            <button className="menuOpc">Carga de layouts</button>
          </div>
          <div className="col menu-item text-center" onClick={() => navigate('/reportes')}>
            <img src={ReportesEsp} alt="Reportes Especiales" className="menu-icon mb-3" /> <br />
            <button className="menuOpc">Reportes Especiales</button>
          </div>
        </div>
      </center>
    </div>
  );
}

export default MenuOpciones;
